import { Color } from "../enums/Color";

export const invoicePaymentPage = {
    mobile: {
        mainWrapper: {
            display: "flex",
            flexDirection: "column" as "column",
        },
        leftWrapper: {},
        rightWrapper: {},
        backButton: {
            container: {
                display: "flex",
                alignItems: "center",
                margin: "5.79vw 4.83vw"
            },
            button: {
                paddingTop: "0.7vw",
                width: "6.76vw",
                height: "6.76vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "50%"
            },
            icon: {
                fill: Color.DeepBlack,
                width: "50%"
            },
            text: {
                display: "inline",
                marginLeft: "2.65vw",
                fontSize: "3.86vw",                
                color: Color.LightBlack
            },
            profileWrapper: {
                display: "none"
            }
        },
        title: {
            fontWeight: "bold" as "bold",
            color: Color.DeepBlack,
            fontSize: "6.03vw"
        },
        pdfViewer: {
            margin: "5.79vw 4.83vw"
        },
        invoiceViewer: {
            rowWrapper: {
                display: "flex",
                flexDirection: "row",
                marginTop: "3.23vh"
            },
            text: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw"
            },
            link: {
                marginLeft: "6.62vw",
                textDecoration: "none",
                color: Color.Blue,
                textAlign: "center",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                fontSize: "3.86vw"
            },
            icon: {
                marginLeft: "0.92vw",
                stroke: Color.Blue,
                width: "3.41vw",
                height: "3.41vw"
            },
            button: {
                marginLeft: "auto",
                width: "32.36vw",
                height: "8.45vw",                
                borderRadius: "2.41vw",
                fontSize: "4.34vw",
                border: "2px solid " + Color.Green,
                color: Color.LightBlack,
                backgroundColor: Color.White
            },
            holder: {
                position: "relative" as "relative",
                border: "1px solid " + Color.MiddleAsh,
                borderRadius: "2.41vw",
                height: "122.46vw",
                width: "90.33vw",
                margin: "5.79vw 0 7.60vw",
                overflow: "hidden"
            },
            layer: {
                position: "absolute" as "absolute",
                bottom: "0",
                left: "0",
                top: "0",
                right: "0",
                background: "transparent linear-gradient(180deg, #00000000 0%, #000000 100%) 0% 0% no-repeat padding-box"
            },
            documentViewer: {
                height: "122.46vw",
                width: "90.33vw"
            }
        },
        popup:{
            justifyContent: "center",
            container: {
                width: "90.33vw",
                height: "130.67vw",
                borderRadius: "2.41vw",
                padding: "2.41vw"
            },
            closeButton: {
                width: "3.86vw",
                height: "3.86vw",
                top: "1.93vw",
                right: "1.93vw"
            },
            documentViewer: {
                height: "100%"
            }
        },
        checkout: {
            width: "85vw",
            marginLeft: "auto",
            marginRight: "auto",
            borderTop: "1px solid " + Color.MiddleAsh,
            priceRow: {
                display: "flex" as "flex",
                fontSize: "6.76vw",
                alignItems: "center" as "center",
                fontWeight: "bold" as "bold",
                marginLeft: "4vw"
            },
            priceValue: {                    
                fontSize: "6.76vw",
                fontWeight: "bold" as "bold",
                marginLeft: "auto",
                marginRight: "4vw"
            },
            checkoutButton: {
                width: "100%",
                height: "5.58vh",
                border: "none",
                color: Color.White,
                background: Color.Green,
                fontWeight: "bold" as "bold",
                fontSize: "4.35vw",
                borderRadius: "2.41vw",
                marginTop: "3.2vw"
            },
            iconGride: {
                display: "flex",
                justifyContent: "center",
                margin: "3.57vh 0"
            },
            paymentIcon: {
                maxWidth: "17.21vw",
                maxHeight: "5.83vw",
                margin: "0 1.93vw 0 0",
                WebkitFilter: "grayscale(1)", 
                filter: "grayscale(1)"
            },
            note: {
                color: Color.Green,
                fontSize: "3.86vw",
                textAlign: "center"
            }
        }
    },
    desktop: {
        mainWrapper: {            
            flexDirection: "row" as "row",
            padding: "1.56vw",
            hidePaddingTop: {
                paddingTop: "0"
            }
        },        
        leftWrapper: {},
        rightWrapper: {
            width: "100%",
            paddingLeft: "2.32vw"
        },
        backButton: {   
            container: {
                margin: "0"
            },         
            button: {
                paddingTop: "0.3vw",
                backgroundColor: Color.Ash, 
                width: "2.60vw",
                height: "2.60vw"
            },
            text: {
                marginLeft: "1.3vw",
                fontSize: " 0.93vw",
                fontWeight: 'bold'
            },
            profileWrapper: {
                display: "flex",
                marginLeft: "auto"
            }          
        },
        title: {
            marginTop: "1.97vw",
            fontSize: "2.6vw"
        },
        invoiceWrapper: {
            display: "flex",
            margin: "2.08vw 0 0 0"
        },
        pdfViewer: {
            width: "44.43vw",
            margin: "0"
        },
        checkout: {
            width: "25vw",
            marginBottom: "10vw",
            priceRow: {
                fontSize: "1.46vw",
                marginLeft: 0
            },
            priceValue: {                    
                fontSize: "1.46vw",
                marginRight: 0
            },
            checkoutButton: {
                height: "2.60vw",
                fontSize: "1.04vw",
                borderRadius: "0.52vw",
                marginTop: "1.15vw"
            },
            iconGride: {
                margin: "1.66vw 0 0 0"
            },
            paymentIcon: {
                maxWidth: "5.10vw",
                maxHeight: "1.51vw",
                margin: "0 0.83vw 0 0"
            },
            note: {
                fontSize: "0.83vw"
            }
        }
    }
}